import React from "react"
import { Redirect } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login.jsx"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//Icons
import IconBoxicons from "../pages/Icons/IconBoxicons"
import IconDripicons from "../pages/Icons/IconDripicons"
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
import IconFontawesome from "../pages/Icons/IconFontawesome"

//Pages
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import PagesTimeline from "../pages/Utility/pages-timeline"
import PagesFaqs from "../pages/Utility/pagesFaqs"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

//Concepts
import Concept from "../pages/Concept/Concept"
import TypeConcept from "../pages/Concept/TypeConcept"
//Areas
import AreaUser from "pages/Areas/areaList"
//monitor
import Monitor from "pages/monitor/monitor"
import Users from "pages/User/Users"

//Proveedores
import Supplier from "../pages/Supplier/Supplier"

//Banks
import Banks from "../pages/Banks/Bank"
import PaymentDetail from "pages/PaymentDetaill/PaymentDetail.jsx"

//Files
import FileRequirement from "pages/FilesRequirement/FileRequirement.jsx"

//Files
import UploadFiles from "pages/FilesUpload/UploadFiles.jsx"
// Notification email
import NotificationsEmail from "pages/NotificationsEmail/NotificationsEmail.jsx"

//Material
import MaterialSupplier from "pages/MaterialSupplier/MaterialSupplier.jsx"

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  // Icons
  { path: "/icons-boxicons", component: IconBoxicons },
  { path: "/icons-dripicons", component: IconDripicons },
  { path: "/icons-materialdesign", component: IconMaterialdesign },
  { path: "/icons-fontawesome", component: IconFontawesome },

  //Utility

  { path: "/pages-timeline", component: PagesTimeline },
  { path: "/pages-faqs", component: PagesFaqs },

  //concept
  { path: "/type", component: Concept },
  { path: "/type/:id?", component: TypeConcept },

  //usuarios
  { path: "/users", component: Users },
  //areas
  { path: "/area", component: AreaUser },
  //proveedores
  { path: "/suppliers", component: Supplier },
  // Banks
  { path: "/banks", component: Banks },
  //Monitor Pagos
  { path: "/paymentDetail", component: PaymentDetail },
  //estado de cuentas
  { path: "/account_status", component: Monitor },
  // Configuracion de correos para notificaciones
  { path: "/conf-notificaciones", component: NotificationsEmail },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  // Files requirement
  { path: "/files-requirement", component: FileRequirement },
  // Upload Files
  { path: "/files-upload", component: UploadFiles },
  //Material Supplier
  { path: "/material-supplier", component: MaterialSupplier },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  
  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
]

export { authProtectedRoutes, publicRoutes }
